import Badge from "ds/components/Badge";
import { RunPolicyReceipt } from "types/generated";
import Tree from "ds/components/Tree";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryPolicy from "components/Run/elements/HistoryEntryPolicy";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";

import { RunEntryEvaluationProps, RunHistoryEntryType } from "../../types";
import { useVisibilityToggle } from "../../hooks/useVisibilityToggle";

type InitializationPoliciesEntryProps = RunEntryEvaluationProps & {
  openListByDefault: boolean;
  list: RunPolicyReceipt[];
  stackId: string;
  runId: string;
  isModuleRun: boolean;
};

const InitializationPoliciesEntry = ({
  openListByDefault,
  list,
  evaluationLabel,
  evaluationBadgeVariant,
  evaluationTimestamp,
  stackId,
  runId,
  isModuleRun,
}: InitializationPoliciesEntryProps) => {
  const [show, toggle] = useVisibilityToggle(openListByDefault);

  const label = (
    <>
      <HistoryEntryLabel>
        <strong>Initialization policies</strong> evaluated to
      </HistoryEntryLabel>
      <Badge text={evaluationLabel.toUpperCase()} variant={evaluationBadgeVariant} type="strong" />
    </>
  );

  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.InitializationPolicies}
      timestamp={evaluationTimestamp}
      onClick={toggle}
      isOpen={show}
      label={label}
      terminal
    >
      {show && (
        <Tree padding="0 0 0 large">
          {list.map((policy) => (
            <HistoryEntryPolicy
              key={policy.id}
              item={policy}
              runId={runId}
              stackId={stackId}
              isModuleRun={isModuleRun}
            />
          ))}
        </Tree>
      )}
    </HistoryEntryWrapper>
  );
};

export default InitializationPoliciesEntry;
